export const storage = {
  get: <T>(key: string, fallback: T): T => {
    try {
      const item = localStorage.getItem(key);
      return item ? (JSON.parse(item) as T) : fallback;
    } catch {
      return fallback;
    }
  },

  set: <T>(key: string, value: T): void => {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch {
      console.warn(`Failed to save "${key}" to localStorage`);
    }
  },

  remove: (key: string): void => {
    try {
      localStorage.removeItem(key);
    } catch {
      console.warn(`Failed to remove "${key}" from localStorage`);
    }
  },

  clear: (): void => {
    try {
      localStorage.clear();
    } catch {
      console.warn('Failed to clear localStorage');
    }
  },
};

export const STORAGE_KEYS = {
  CART: 'beauty_sports_cart',
  WISHLIST: 'beauty_sports_wishlist',
  AUTH_TOKEN: 'beauty_sports_token',
  AUTH_USER: 'beauty_sports_user',
  RECENT_SEARCHES: 'beauty_sports_recent_searches',
  VIEW_MODE: 'beauty_sports_view_mode',
} as const;


